// @flow


import LinkPopup from '@components/popups/Link';
import * as PresentationSolitaireContent from '@components/popups/content/PresentationSolitaire';

function PromoDescription() {
  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      Our Presentation Solitaire may be exchanged for one full year after
      purchase. (
      <LinkPopup initialContent={PresentationSolitaireContent}>
        details
      </LinkPopup>
      )
    </div>
  );
}

export default PromoDescription;
